/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MaintenanceCriteriaFullModel } from '../../models/maintenance-criteria-full-model';

export interface GetMaintenanceCriteriaFull$Params {
  patientID?: number;
}

export function GetMaintenanceCriteriaFull(http: HttpClient, rootUrl: string, params?: GetMaintenanceCriteriaFull$Params, context?: HttpContext): Observable<StrictHttpResponse<MaintenanceCriteriaFullModel>> {
  const rb = new RequestBuilder(rootUrl, GetMaintenanceCriteriaFull.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MaintenanceCriteriaFullModel>;
    })
  );
}

GetMaintenanceCriteriaFull.PATH = '/api/Supervisor/GetMaintenanceCriteriaFull';
